import { create } from 'zustand'
import { cloneDeep } from 'lodash-es'
import { triggerEvent } from '@/utils/customEvent.ts'

const createState = () =>
  cloneDeep({
    chatState: {
      chatTabKey: 'MESSAGE', // 一级tab
      chatActive: null,
      activeDict: {},
      todoTabKey: 'todo', // 待办事项 - tab
      countDict: {},
    },
    chatData: {
      ['ALL']: [
        {
          id: 1,
          name: '匠人智家',
          message: '你好',
          time: '2021-01-01',
          from: '@李文 向你发送一条质检验收请求',
          desc: '贴心的家装管家',
        },
        {
          id: 2,
          name: '营销宝',
          message: '你好',
          time: '2021-01-01',
          from: '@李文 向你发送一条质检验收请求',
          desc: '贴心的家装管家',
        },
      ],
      ['MESSAGE']: [
        // {
        //   id: 21,
        //   name: 'Hello',
        //   message: '你好',
        //   time: '2021-01-01',
        //   from: '@李文 向你发送一条质检验收请求',
        //   desc: '贴心的家装管家',
        // },
        // {
        //   id: 22,
        //   name: 'haha',
        //   message: '你好',
        //   time: '2021-01-01',
        // },
      ],
    },
    todoData: {
      TODO: [
        {
          id: 31,
          name: 'APP',
          message: '你好',
          time: '2021-01-01',
          from: '@李文 向你发送一条质检验收请求',
          desc: '贴心的家装管家',
        },
        {
          id: 32,
          name: 'MINI_PROGRAM',
          message: '你好',
          time: '2021-01-01',
        },
      ],
    },
    messageData: {},
    messageState: {
      scroll: {},
      noMore: {},
      loading: {},
    },
    updateTimeMap: {},
  })
export const getDialogKey = chatState =>
  chatState.chatTabKey + chatState.activeDict?.[chatState.chatTabKey]?.id

const useChatStore = create((set, get: any) => ({
  ...createState(),
  reset: () => {
    set(() => ({ ...createState() }))
  },
  setState: (key, value) => {
    set(state => ({ [key]: Object.assign({}, state[key], value) }))
  },
  setChatState: chatState =>
    set(state => ({ chatState: Object.assign({}, state.chatState, chatState) })),
  chatSelect: (record, key?) => {
    const { chatState, setChatState } = get()
    const activeDict = chatState.activeDict
    activeDict[key || chatState.chatTabKey] = record
    setChatState({ chatActive: record, activeDict })
  },
  setChatData: chatData => {
    return set(state => {
      return { chatData: Object.assign({}, cloneDeep(state.chatData), chatData) }
    })
  },
  setChatDataCount: countList => {
    const chatState = get?.().chatState
    countList.map(d => {
      chatState.countDict[d.fromId] = d.unReadCount
    })
    return set(state => ({ chatState: Object.assign({}, state.chatState, chatState) }))
  },
  getChatData: params => {
    const chatData = get?.().chatData
    return chatData[params.type]
  },
  setScroll: (scrollTop, key?) => {
    const messageState = get?.().messageState
    const chatState = get?.().chatState
    const _key = key || getDialogKey(chatState)
    messageState.scroll[_key] = scrollTop
    set(() => ({ messageState }))
  },
  setMessageState: messageState =>
    set(state => ({ messageState: Object.assign({}, state.messageState, messageState) })),
  setMessageData: (id, list) => {
    const messageData = get?.().messageData
    messageData[id] = list
    return set(() => ({ messageData: { ...messageData } }))
  },
  setMessageDataLastUpdatedTime: (id, time) => {
    return set(state => ({ updateTimeMap: { ...state.updateTimeMap, [id]: time } }))
  },
  insertMessageData: (id, nextList) => {
    const messageData = get?.().messageData
    const chatState = get?.().chatState
    const key = getDialogKey(chatState)
    messageData[key] = [...nextList, ...messageData[key]]
    set(() => ({ messageData: { ...messageData } }))
  },
  appendMessageData: (nextList, key) => {
    const messageData = get?.().messageData
    const chatState = get?.().chatState
    const _key = key || getDialogKey(chatState)
    messageData[key] = [...messageData[_key], ...nextList]
    set(() => ({ messageData: { ...messageData } }))
  },
  getTodoData: (params?) => {
    const todoData = get?.().todoData
    const chatState = get?.().chatState
    return todoData[params?.type || chatState.todoTabKey]
  },
  setTodoData: (tab, data) =>
    set(state => {
      const todoData = Object.assign({}, state.todoData, { [tab]: data })
      return { todoData }
    }),
  pullDialogData: async (fetchFunc, { key, active } = {}) => {
    const { chatState, messageData, messageState, appendMessageData } = get?.() || {}
    const activeId = key || getDialogKey(chatState)
    const _active = active || chatState.activeDict?.[chatState.chatTabKey]
    if (messageState.loading?.[activeId]) return Promise.reject('loading')
    const list = messageData[activeId]
    if (!list) return Promise.reject('no data')
    const lastItem = list?.[list.length - 1]
    return fetchFunc?.(_active, lastItem).then(items => {
      appendMessageData(items, activeId)

      const itemEl: any = document.querySelector(`#MESSAGE_${lastItem.uid}`)
      setTimeout(() => {
        const scrollTop = itemEl?.offsetTop || 0
        triggerEvent('SCROLL_TO_FIX', scrollTop - 60)
      }, 0)
      return Promise.resolve([items])
    })
  },
}))

export default useChatStore
